import { Component, OnInit } from '@angular/core';
import { throwError, Observable, empty, of } from 'rxjs'

import { ConfigService } from '../../services/config.service';
import { TranslationService } from '../../services/translation.service';

import { SimulatorConfig, NavBarLink }  from '../../classes/';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent implements OnInit {

	getTranslator():TranslationService{
		return this.translator;
	}
	getConfig():ConfigService{
		return this.config;
	}	

	constructor(private config: ConfigService,private translator: TranslationService){

	};

	ngOnInit() {
	}

}
